<template>
  <div class="file-block">
    <img
      src="@/assets/AttachementIcon.svg"
      alt="attachment-icon"
      class="document-icon"
    />
    <div class="document-details">
      <div
        class="document-name"
        @click="downloadDocument"
      >
        {{ document.name }}
      </div>
      <div
        class="document-properties"
        v-if="document.size"
      >
        {{ readableBytes(document.size) }}
      </div>
    </div>
    <div class="spacer" />
  </div>
</template>

<script>
import config from '@/config'
import axios from 'axios'

export default {
  name: 'PostAttachment',
  props: {
    document: {
      type: Object,
      required: false,
      default: () => {
      }
    }
  },
  methods: {
    readableBytes (bytes) {
      const i = Math.floor(Math.log(bytes) / Math.log(1024))
      const sizes = [ 'B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB' ]
      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[ i ]
    },
    async downloadDocument () {
      const document = this.document
      const response = await axios.get(`${config.getRootApi()}/documents/${document.idDocument}`, { responseType: 'blob' })
      this.createDownloadLink(document.name, document.type, response.data)
    },
    createDownloadLink (fileName, fileType, bytes) {
      let blob = new Blob([ bytes ], { type: fileType + ';charset=utf-8' })
      if (navigator.appVersion.toString().includes('.NET')) {
        window.navigator.msSaveBlob(blob, fileName)
      } else {
        const url = window.URL.createObjectURL(new Blob([ bytes ], { type: fileType }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.file-block {
    display: flex;
    align-items: center;
    height: 44px;
    border-radius: 3px;

    .document-icon {
        width: 30px;
        height: 34px;
    }

    .document-details {
        margin: 2px 0 0 8px;
        text-align: left;

        .document-name {
            font-family: OpenSans-Bold, sans-serif;
            font-size: 14px;
            color: $black-color;
            letter-spacing: 0;
            line-height: 21px;
            cursor: pointer;
        }

        .document-properties {
            font-family: OpenSans-Regular, sans-serif;
            font-size: 13px;
            color: #999999;
            letter-spacing: 0;
            line-height: 19px;
            font-weight: normal;
        }
    }

    .spacer {
        flex-grow: 1;
    }

    .delete-icon {
        margin-right: 18px;
        cursor: pointer;
    }

}
</style>
